import type { User } from '../firebase/firebase';
import { AllInvoicingCompaniesResponse } from '../models/Integrations/IntegrationElements';
import {
	defaultCloudFunctionServices,
	makeCloudFunctionRequestDeprecated,
} from './BaseCloudFunctionRequests';
import { HTTPSCloudFunctionURLs } from './HTTPSCloudFunctionURLs';

export const fetchInvoicingContactIDs = async (
	abortSignal: AbortSignal,
	user: User,
): Promise<AllInvoicingCompaniesResponse | undefined> => {
	return await makeCloudFunctionRequestDeprecated<AllInvoicingCompaniesResponse>(
		{
			abortSignal,
			user,
			url: HTTPSCloudFunctionURLs.InvoicingCompanyIDs,
			method: 'GET',
			services: defaultCloudFunctionServices,
		},
	);
};
